import { h, Fragment } from 'preact'
import cx from '../../shared/classes'
import style from './button-group-selector.css'

export interface Option {
    key: string
    value: string
}

interface Props {
    items: Option[]
    value: string
    disabled?: boolean
    onSelect: (value?: string) => void
    className?: string
}

const ButtonGroupSelector: preact.FunctionalComponent<Props> = (props) => {
    const { items, onSelect, disabled, value, className } = props
    const handleSelectItem = (selectedValue: string) => () => {
        if (selectedValue === value) {
            onSelect(undefined)
            return
        }

        onSelect(selectedValue)
    }

    const renderButtons = () => {
        return (
            <div class={className}>
                {items.map((item) => {
                    return (
                        <button
                            key={item.key}
                            disabled={disabled}
                            class={cx({
                                [style.button]: true,
                                [style.buttonDisabled]: disabled,
                                [style.buttonSelected]: item.key === value,
                            })}
                            onClick={handleSelectItem(item.key)}
                            role="radio"
                            aria-checked={item.key === value}
                        >
                            {item.value}
                        </button>
                    )
                })}
            </div>
        )
    }

    return (
        <div
            class={cx({
                [style.buttongroupSelector]: true,
                [style.buttongroupSelectorDisabled]: disabled,
            })}
        >
            <div class={style.buttongroupContainer}>
                <div class={style.buttongroupList}>{renderButtons()}</div>
            </div>
        </div>
    )
}

export default ButtonGroupSelector
